import { DateTime } from "luxon"

import { getKPIRequest } from "@/api/getKPIRequest"
import type { KPI, KPIGroupRequest } from "@/types/kpiTypes"

import KPIRequests from "../config/config"

export const getKPIExportData = async (
  location: number,
  start: Date,
  end: Date,
): Promise<KPI[]> => {
  const request: KPIGroupRequest = {
    kpis: KPIRequests.get(location) || [],
    aggType: "Daily",
    startDate: DateTime.fromJSDate(start).toISODate() || "",
    endDate: DateTime.fromJSDate(end).toISODate() || "",
  }

  return await getKPIRequest(request)
}
